module.exports = __webpack_public_path__ + "static/media/bank_jsyh.2ec1452c.png";